export default function OneTrust(): JSX.Element {
	const oneTrustID = process.env.NEXT_PUBLIC_ONETRUST_ID;

	if (!oneTrustID || oneTrustID.toLocaleLowerCase().includes('-test')) {
		return <></>;
	}

	return (
		<>
			<script async src={`https://cdn.cookielaw.org/consent/${oneTrustID}/OtAutoBlock.js`} type="text/javascript" />

			<script async src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js" type="text/javascript" data-domain-script={oneTrustID} />

			<script src="/OptanonWrapper.js" type="text/javascript" defer />
		</>
	);
}
